<div class="ui-g-12">

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
    <h2>{{ translations.FunnelMarketing11 }}</h2>
    <div class="chart-container">
      <chart [options]="waterfallContactabilityChart.options"
             (load)="setChartInstance(waterfallContactabilityChart, $event.context)"></chart>
    </div>
  </div>

  <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
    <h2>{{ translations.ContactabilityForValue }}</h2>
    <div class="chart-container">
      <chart [options]="segmentContactabilityChart.options"
             (load)="setChartInstance(segmentContactabilityChart, $event.context)"></chart>
    </div>
  </div>

  <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
    <p>{{ selectOneError }}</p>
    <div class="ui-dialog-footer">
      <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-contactable/contactable-main-kpi/contactable-main-kpi.component.html